"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
/**
 * This is the page that Stripe will redirect to if the user is using a redirect-based payment method.
 * We're using Stripe exclusively with card payments in North America, so since we have set Stripe's redirect
 * option to "if_required", we don't expect to ever hit this page. If for some reason we do get a redirect
 * though, we need to tell the customer that we didn't update their payment method and encourage the customer
 * to let CS know so that we can re-think our assumption that we'll never have to deal with a redirect-based
 * payment method. We give the customer an error code by which we can identify this particular issue that we
 * never expect to encounter.
 */
var UpdateCreditCardFailed = function () {
    return (react_1.default.createElement("div", { className: 'margin-vertical-8 account-container update-credit-card-stripe-container' },
        react_1.default.createElement("div", { className: 'panel space-y-4' },
            "Your credit card information could not be updated. Please",
            ' ',
            react_1.default.createElement("a", { className: 'text-wedgewood', href: 'https://localhost:3000/pages/contact' }, "contact Customer Support"),
            ' ',
            "and provide them with error code HB9004.")));
};
exports.default = UpdateCreditCardFailed;
